import React from 'react';

export const RemixIcon = ({
  width = 24,
  height = 24,
  color = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 6C9.68629 6 7 8.68629 7 12H9L6 15L3 12H5C5 7.58172 8.58172 4 13 4V6Z"
      fill={color}
    />
    <path
      d="M11 18C14.3137 18 17 15.3137 17 12L15 12L18 9L21 12H19C19 16.4183 15.4183 20 11 20V18Z"
      fill={color}
    />
  </svg>
);
